import React, { PropsWithChildren } from "react";

import Tooltip from "@mui/material/Tooltip";

import { HELP_DOCS_DEFAULT_BASE_URL } from "../slices/help_docs";
import { useSelector } from "../store";
import { QuestionMarkCircle } from "./icons";

interface HelpInfoProps extends PropsWithChildren {
  docsKey: string;
  variant?: "primary" | "warning";
  description?: string;
}

const HelpInfo = ({
  docsKey,
  variant = "primary",
  description,
}: HelpInfoProps) => {
  const info = useSelector((state) =>
    Object.prototype.hasOwnProperty.call(state.helpDocs.helpDocs, docsKey)
      ? state.helpDocs.helpDocs[docsKey]
      : null,
  );

  if (!info || (!info?.path && !info?.description)) {
    return <></>;
  }

  const craftUrl = (): string => {
    if (!info?.path) {
      return "";
    }
    const parsed = info.path.split("#");
    let url =
      HELP_DOCS_DEFAULT_BASE_URL +
      "/docs/reference" +
      parsed[0] +
      "?utm_source=zero&utm_medium=console&utm_campaign=docs-tracking";
    if (parsed[1]) {
      url += "#" + parsed[1];
    }
    return url;
  };

  return (
    <Tooltip title={description || info?.description || ""}>
      <a
        id={docsKey}
        href={craftUrl()}
        target="_blank"
        style={{
          textDecoration: "none",
        }}
      >
        <span className="sr-only">
          {info?.title ? `Open docs: ${info.title}` : "Open documentation"}
        </span>
        <QuestionMarkCircle
          color={variant}
          aria-hidden="true"
          style={{ width: 16, height: 16, display: "block" }}
        />
      </a>
    </Tooltip>
  );
};

export default HelpInfo;
